import { render, staticRenderFns } from "./ContractResume.vue?vue&type=template&id=58d15490&scoped=true&"
import script from "./ContractResume.vue?vue&type=script&lang=js&"
export * from "./ContractResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d15490",
  null
  
)

export default component.exports